import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container m-auto p-4 md:py-6">
      <div className="text-grey-1000 leading-normal">
        <div>
          <div className="text-justify">
            <h2 className="text-2xl font-semibold mb-1 leading-loose">
              Privacy Policy
            </h2>

            <div className="mb-3">
              <p>
                Welcome to Yatra Tickets Pvt. Ltd. ("Yatra Tickets," "we," "us," or "our"). This Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you use our online travel agent portal and related services. By using our website or services, you consent to the practices described herein.
              </p>
            </div>
            <div className="mb-3">
              We collect personal information that you provide to us, including your name, contact details (such as phone number and email address), payment information (e.g., credit card details), and travel preferences and details (like flight itineraries and hotel bookings). In addition to personal information, we also gather non-personal information that does not identify you personally, such as browser type, IP address, device information, and usage data (e.g., pages visited and time spent on our site).
            </div>
            <div className="mb-3">
              The personal information we collect is used to process and manage bookings and transactions, provide customer support, send booking confirmations, updates, and promotional offers (if you opt in), improve our services and website functionality, and comply with legal obligations. We may share your personal information with third-party service providers who assist us in delivering travel services, including airlines, hotels, and payment processors. These providers are obligated to protect your information and use it only for the purposes for which it was disclosed.
            </div>
            <div className="mb-3">
              We may also disclose your information if required by law, regulation, or legal process, or to protect our rights or the rights of others. In the event of a merger, acquisition, or sale of all or part of our business, your information may be transferred as part of that transaction.

            </div>
            <div className="mb-3">
              Our website uses cookies and similar tracking technologies to enhance your experience, analyze site usage, and personalize content. Cookies are small files stored on your device that help us recognize you and your preferences. You can manage your cookie preferences through your browser settings.
            </div>
            <div className="mb-3">
              We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
            </div>
            <div className="mb-3">
              You have the right to access and correct your personal information held by us. You can update your details through your account or by contacting us directly. If you no longer wish to receive marketing communications from us, you can opt-out by following the unsubscribe instructions provided in the emails or by contacting us. Additionally, you may request the deletion of your personal information, subject to legal and contractual obligations, though some information may be retained for administrative purposes.

            </div>
            <div className="mb-3">
              Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of these sites and encourage you to review their privacy policies. Our services are not intended for children under 18. We do not knowingly collect personal information from children, and if you believe your child has provided us with such information, please contact us to have it removed.
            </div>
            <div className="mb-3">
              Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of these sites and encourage you to review their privacy policies. Our services are not intended for children under 18. We do not knowingly collect personal information from children, and if you believe your child has provided us with such information, please contact us to have it removed.
            </div>


            <div className="mb-3">
              We may update this Privacy Policy periodically, and any changes will be posted on our website with an updated effective date. We encourage you to review this policy periodically to stay informed about how we protect your information.
            </div>
            <div className="mb-3">
              If you have any questions or concerns about this Privacy Policy or our practices, please contact us at:
              <p className="mt-2">
                <b>
                  Yatra Tickets Pvt. Ltd.
                </b>
              </p>
              <p>
                <b>
                  5th Floor Kamaladi Complex, Kathmadu
                </b>
              </p>
              <p>
                <b>
                  tickets@yatratickets.com
                </b>
              </p>

              <p className="mt-2">
                By using our services, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.
              </p>
            </div>


          </div>
          {/* <div>
        <h2 className="text-2xl font-semibold mb-1 leading-loose">
          Our Vision
        </h2>
        <p className="mb-3">
          To make Gandaki Tours &Travels the leading travel and trade
          company in the country by promoting tourism industry of Nepal
          thereby, creating employment,opportunities for locals and
          generating revenue for development.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-semibold mb-1 leading-loose">
          Our Mission
        </h2>
        <p className="mb-3">
          To provide reliable and quality services to all our valued
          customers according to their need and convenience giving full
          satisfaction with the best value of money they spend.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-semibold mb-1 leading-loose">
          Membership
        </h2>
        <p className="mb-3">
          To provide reliable and quality services to all our valued
          customers according to their need and convenience giving full
          satisfaction with the best value of money they spend.
        </p>
      </div> */}
        </div>
      </div>
    </div >)
}
export default PrivacyPolicy;
